import { render, staticRenderFns } from "./TabSizes.vue?vue&type=template&id=5ba59f24&"
import script from "./TabSizes.vue?vue&type=script&lang=js&"
export * from "./TabSizes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports